import React from 'react'

export const TemplateContext = React.createContext({})

export const TemplateConsumer = TemplateContext.Consumer
